<div class="d-flex align-items-center condensed my-2 mx-1" mat-dialog-title>
    <div class="spacer title">{{ data.title }}</div>

    @if (data.close) {
        <div>
            <button [mat-dialog-close]="ConfirmDialogResult.Cancelled" mat-icon-button tabindex="-1">
                <i class="fas fa-times"></i>
            </button>
        </div>
    }
</div>

<mat-dialog-content>
    @if (data.text) {
        <p [innerHTML]="data.text"></p>
    }

    @if (data.radio) {
        <mat-radio-group [(ngModel)]="selectedOption">
            @for (option of data.options; track option) {
                <mat-radio-button
                    class="option"
                    [value]="option.value"
                    (dblclick)="optionClicked(option, true)"
                    (click)="optionClicked(option)"
                    >{{ option.name }}</mat-radio-button
                >
            }
        </mat-radio-group>
    } @else if (data?.options?.length > 0) {
        <div>
            @for (option of data.options; track option) {
                <div
                    class="option"
                    [style.background-color]="option.bgColor"
                    [class.disabled]="option.disabled"
                    (click)="optionClicked(option)">
                    <div class="d-flex align-center align-items-center w-100 gap-3">
                        @if (data.multiSelect) {
                            <input
                                class="me-2"
                                [checked]="isSelected(option)"
                                [disabled]="option.disabled"
                                (click)="$event.stopPropagation()"
                                type="checkbox"
                                readonly />
                        }

                        @if (option.icon) {
                            <i class="me-2" [class]="'fa ' + option.icon"></i>
                        }

                        <div class="d-flex flex-grow-1 flex-column align-items-stretch min-width-0">
                            <div class="d-flex justify-content-between gap-2">
                                <span class="text-ellipsis">{{ option.name }}</span>
                                @if (option.rightText) {
                                    <small class="text-ellipsis flex-shrink-0">{{ option.rightText }}</small>
                                }
                            </div>

                            @if (option.subtext) {
                                <small>{{ option.subtext }}</small>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-between pt-3">
    @if (data.cancel) {
        <button [mat-dialog-close]="ConfirmDialogResult.Secondary" [class]="data.cancelClass" mat-button>
            {{ data.cancel }}
        </button>
    }

    <div class="spacer"></div>

    @if (data.confirm && (data.radio || data.options)) {
        <button
            [disabled]="data.radio && !selectedOption"
            (click)="onConfirm()"
            cdkFocusInitial
            mat-raised-button
            color="primary">
            {{ data.confirm }}
        </button>
    } @else if (data.confirm) {
        <button
            [disabled]="data.radio && !selectedOption"
            (click)="onConfirm()"
            cdkFocusInitial
            mat-raised-button
            color="primary">
            {{ data.confirm }}
        </button>
    }
</mat-dialog-actions>
